/* src/app/rating/vote/vote.component.scss */
.absolute-divs {
  margin: 0;
  padding: 0;
  z-index: 2;
  position: absolute;
  transform: translate(-50%, 0);
  width: 71.2%;
  left: 50%;
}
.voting-container {
  height: 9.93%;
  bottom: 26.43%;
  display: flex;
  -webkit-transition: opacity 300ms ease-in-out;
  -moz-transition: opacity 300ms ease-in-out;
  -o-transition: opacity 300ms ease-in-out;
  transition: opacity 300ms ease-in-out;
}
.svg-bg {
  width: auto;
  height: auto;
  z-index: 2;
  background-size: contain;
  background-repeat: no-repeat;
  transition: 200ms;
  transition-timing-function: ease-in-out;
  -webkit-transition: 200ms;
  -webkit-transition-timing-function: ease-in-out;
  cursor: pointer;
  display: block;
  margin: 0 auto;
}
.vote-group,
.submit-vote-group {
  height: 100%;
}
.vote-group {
  width: 64.25%;
}
.submit-vote-group {
  margin-top: 2px;
  width: 35.75%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.submit-vote-group a {
  margin-top: 4%;
}
.vote-group .info-title {
  text-align: left;
  font-family: "Campton-Bold";
}
.vote-group .info-group .min,
.vote-group .info-group .max {
  float: left;
  width: 50%;
  font-size: 1rem;
}
.vote-group .info-group .min {
  text-align: left;
}
.vote-group .info-group .max {
  text-align: right;
}
.interval-group {
  border: 1px solid #ffffff;
  height: 33%;
  width: 100%;
  margin: 4px 0px;
  position: relative;
}
.interval-group .selector {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  background-color: #6dcc09;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
}
.instructions {
  text-align: left;
  margin-top: 10px;
  font-size: 14px;
}
/*# sourceMappingURL=vote.component.css.map */
